import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreJoyride } from '../../../Types/StoreTypes';

const initialState: StoreJoyride = {
    run: false,
    stepIndex: 0,
    startTour: false,
};

const joyrideSlice = createSlice({
    name: 'joyride',
    initialState,
    reducers: {
        setRun: (state, action: PayloadAction<StoreJoyride['run']>) => {
            state.run = action.payload;
        },
        setStepIndex: (state, action: PayloadAction<StoreJoyride['stepIndex']>) => {
            state.stepIndex = action.payload;
        },
        setStartTour: (state, action: PayloadAction<StoreJoyride['startTour']>) => {
            state.startTour = action.payload;
        },
    },
});

export const { setRun, setStepIndex, setStartTour } = joyrideSlice.actions;

export default joyrideSlice.reducer;
